/* Purry Home — submit feedback for storefront forms (contact, trade application).
   Shopify posts the form as a full page load, which can take a few seconds; the
   button shows "Sending…", a spinner and is locked so it can't be pressed twice. */
(() => {
  const SEL = 'form#ContactForm, form#TradeApply, form[action$="/contact"]';
  document.addEventListener('submit', (e) => {
    const form = e.target.closest ? e.target.closest(SEL) : null;
    if (!form || e.defaultPrevented) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    const btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!btn || btn.dataset.phBusy) return;
    btn.dataset.phBusy = '1';
    btn.setAttribute('aria-busy', 'true');
    form.setAttribute('aria-busy', 'true');
    const label = btn.textContent.trim();
    const sending = (window.phI18n && window.phI18n.sending) || 'Sending…';
    btn.dataset.phLabel = label;
    if (btn.tagName === 'INPUT') { btn.value = sending; } else { btn.innerHTML = '<span class="ph-spin" aria-hidden="true"></span><span>' + sending + '</span>'; }
    btn.classList.add('is-busy');
    // lock after the submit has been dispatched, so the value of the button is still posted
    setTimeout(() => { btn.disabled = true; }, 0);
  }, true);
  // back/forward cache: restore the button if the page is shown again
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('[data-ph-busy]').forEach((b) => { b.disabled = false; b.removeAttribute('aria-busy'); b.classList.remove('is-busy'); delete b.dataset.phBusy; if (b.dataset.phLabel) b.textContent = b.dataset.phLabel; });
  });
  // after a submit, bring the confirmation into view
  window.addEventListener('DOMContentLoaded', () => {
    const msg = document.querySelector('.ph-trade-form__msg, #ContactForm .form__message, #ContactForm .form-status');
    if (msg && /contact_posted=true|customer_posted=true/.test(location.search)) msg.scrollIntoView({ block: 'center' });
  });
})();
